import { makeStyles } from '@mui/styles';
import { colors } from '../components/Theme/WebTheme';

const styles = (theme) => {
  return {
    toolBar: {
      height: '10vh',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '20px',
      backgroundColor: 'white',
    },
    logo: {
      color: 'blue',
      cursor: 'pointer',
    },
    link: {
      color: "#000"
    },
    menuIcon: {
      color: '#000',
    },
    formContainer: {
      flexGrow: 1,
      padding: '10px',
      maxWidth: '700px',
      margin: '30px auto',
      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%',
      },
    },
    form: {
      marginTop: '30px',
    },
    formHeading: {
      textAlign: 'center',
    },
    heroBox: {
      width: '100%',
      display: 'flex',
      minHeight: '95vh',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      color: '#fff',
      willChange: 'transform',
      // soft dark gradient overlay for legibility
      '&:before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(180deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.55) 100%)',
        zIndex: 1,
      },
      [theme.breakpoints.down('md')]: {
        minHeight: '750px',
      },
    },
    // Global keyframes used by Hero component for the idle animation
    '@global': {
      // Prevent horizontal overflow on mobile and reset default margins
      '*, *::before, *::after': {
        boxSizing: 'border-box'
      },
      'html, body, #root': {
        overflowX: 'hidden',
        margin: 0
      },
      // Global font family and heading weight defaults using Libre Franklin
      'body, html, #root': {
        fontFamily: '"Libre Franklin", "Roboto", "Helvetica", "Arial", sans-serif',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale'
      },
      'h1, h2, h3, h4, h5, h6': {
        fontFamily: '"Libre Franklin", "Roboto", "Helvetica", "Arial", sans-serif',
        margin: 0,
        fontWeight: 700
      },
      'h1': { fontWeight: 800 },
      'h2': { fontWeight: 800 },
      '@keyframes heroIdle': {
      '0%': {
        transform: 'translateY(0px) scale(1)'
      },
      '50%': {
        transform: 'translateY(-16px) scale(1.03)'
      },
      '100%': {
        transform: 'translateY(0px) scale(1)'
      }
      }
    },
    gridContainer: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: '1400px',
      padding: '100px 32px',
      position: 'relative',
      zIndex: 2,
      margin: '0 auto',
      textAlign: 'center'
    },
    [theme.breakpoints.down('sm')]: {
      gridContainer: {
        padding: '56px 16px !important',
        textAlign: 'center'
      }
    },
    aboutUsContainer: {
      width: '100%',
      display: 'flex',
      minHeight: '360px',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '30px 0px 80px 0px',
      padding: '60px 32px'
    },
    aboutUsSubtitle: {
      opacity: '0.9',
      paddingBottom: '32px',
      fontSize: '22px',
      lineHeight: 1.7,
      color: '#3b3b3b'
    },
    titleMain: {
      marginTop:'32px',
      paddingBottom: '16px',
      color: '#fff',
      fontWeight: 800,
      fontSize: 'clamp(28px, 6vw, 48px)'
    },
    title: {
      paddingBottom: '20px'
    },
    subtitleMain: {
      opacity: '0.98',
      paddingBottom: '40px',
      color: '#f2f2f2',
      fontSize: '22px',
      maxWidth: '820px',
      fontWeight: 400
    },
    subtitle: {
      opacity: '0.5',
      paddingBottom: '40px'
    },
    largeImage: {
      width: '100%',
      borderRadius: 24,
      boxShadow: '0 16px 40px rgba(0,0,0,0.16)'
    },
    sectionGridContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      width: '100%',
      gap: 32,
      padding: '32px',
      textAlign: 'center'
    },
    // responsive tweaks for section grids
    [theme.breakpoints.down('sm')]: {
      sectionGridContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        gap: 18,
        padding: '20px 16px',
        textAlign: 'center'
      },
      sectionGridItem: {
        width: '100% !important',
        padding: '18px',
        margin: '8px !important',
        textAlign: 'center'
      },
      sectionGridItem1: {
        maxWidth: '90%',
        padding: '20px',
        textAlign: 'center',
        margin: '12px auto !important'
      }
    },
    sectionGridItem: {
      padding: '32px',
      width: '320px',
      borderRadius: '18px',
      margin: '16px !important',
      transition: 'transform 220ms ease, box-shadow 220ms ease',
      '&:hover': {
      transform: 'translateY(-10px)',
      boxShadow: '0 20px 40px rgba(0,0,0,0.16)'
      }
    },
    /* Car card specific styles to keep images correct and text readable */
    carCard: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 12,
    },
    carImageContainer: {
  width: 180,
  height: 120,
      borderRadius: 12,
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent',
    },
    carImage: {
  width: '100%',
  height: '100%',
  objectFit: 'contain',
      display: 'block',
    },
    carTitle: {
      margin: 8,
      color: '#fff',
      fontSize: 17,
      fontWeight: 800,
      textAlign: 'center'
    },
    // mobile specific overrides
    [theme.breakpoints.down('sm')]: {
      heroBox: {
        minHeight: 'auto',
        height: 'auto',
        alignItems: 'flex-start',
        textAlign: 'center',
        paddingTop: '76px',
        paddingBottom: '28px'
      },
      titleMain: {
        fontSize: 'clamp(22px, 6vw, 34px)',
        textAlign: 'center',
        paddingLeft: '16px',
        paddingRight: '16px'
      },
      subtitleMain: {
        fontSize: '18px',
        textAlign: 'center',
        paddingLeft: '16px',
        paddingRight: '16px',
        lineHeight: 1.5
      },
      carImageContainer: {
        width: 200,
        height: 130,
      },
      carTitle: {
        fontSize: 18,
        textAlign: 'center'
      },
      carPrice: {
        fontSize: '18px',
        textAlign: 'center'
      },
      carText: {
        fontSize: '13px',
        textAlign: 'center',
        lineHeight: 1.4
      },
      aboutUsContainer: {
        padding: '40px 16px',
        textAlign: 'center'
      },
      aboutUsSubtitle: {
        fontSize: '18px',
        textAlign: 'center',
        paddingLeft: '16px',
        paddingRight: '16px'
      }
    },
    carInfoBox: {
      // switch to dark semi-opaque background for vehicle info boxes
      background: 'linear-gradient(180deg, rgba(0,0,0,0.72), rgba(10,10,10,0.6))',
      borderRadius: 20,
      padding: 12,
      width: '100%',
      boxSizing: 'border-box',
      color: colors.WHITE
    },
    carPrice: {
      marginTop: 6,
      fontWeight: '700',
      fontSize: 20,
      color: colors.Button_Primary || '#D4AF37',
      textAlign: 'center'
    },
    carText: {
      marginTop: 6,
      color: colors.WHITE,
      fontSize: 14,
      lineHeight: 1.35,
      wordBreak: 'break-word',
      textAlign: 'center'
    },
    sectionGridItem1: {
      width: '100%',
      maxWidth: '520px',
      borderRadius: '14px',
      padding: '18px',
      // dark gradient to match black card theme
      background: 'linear-gradient(180deg, rgba(11,11,12,0.95), rgba(20,20,20,0.9))',
      color: colors.WHITE,
      border: '1px solid rgba(255,255,255,0.04)',
      textAlign: 'center'
    },
    /* New modern hero / booking card styles */
    heroContent: {
      padding: '20px 12px',
      zIndex: 2,
    },
    // Button row animation: slide up + fade in when scrolled into view
    buttonRow: {
      display: 'flex',
      gap: 12,
      marginTop: 18,
      transition: 'transform 600ms cubic-bezier(0.2,0.8,0.2,1), opacity 600ms ease',
      transform: 'translateY(18px)',
      opacity: 0,
    },
    buttonRowVisible: {
      transform: 'translateY(0)',
      opacity: 1,
    },
    glassCard: {
      // darker semi-opaque background for improved readability over the hero image
      background: 'linear-gradient(180deg, rgba(0,0,0,0.62), rgba(0,0,0,0.5))',
      border: '1px solid rgba(255,255,255,0.06)',
      backdropFilter: 'blur(6px)',
      WebkitBackdropFilter: 'blur(6px)',
      borderRadius: 16,
      padding: 20,
      boxShadow: '0 10px 40px rgba(0,0,0,0.45)',
      color: '#fff',
      transition: 'transform 260ms ease, box-shadow 260ms ease',
      '&:hover': {
        transform: 'translateY(-6px)',
        boxShadow: '0 22px 48px rgba(0,0,0,0.5)'
      }
    },
    ctaButton: {
      borderRadius: 10,
      padding: '12px 22px',
      fontWeight: 800,
      background: 'linear-gradient(90deg, #D4AF37 0%, #B8860B 100%)',
  color: '#fff',
      boxShadow: '0 8px 20px rgba(212,175,55,0.18)',
      textTransform: 'none',
      '&:hover': {
        boxShadow: '0 12px 30px rgba(212,175,55,0.26)'
      }
    },
    secondaryButton: {
      borderRadius: 8,
      padding: '8px 18px',
      background: 'transparent',
      color: '#fff',
      border: '1px solid rgba(255,255,255,0.18)'
    },
    formInput: {
      background: 'rgba(255,255,255,0.06)',
      borderRadius: 8,
      marginBottom: 12,
      width: '100%',
      '& .MuiOutlinedInput-root': {
        minHeight: 54,
        borderRadius: 8,
        color: '#fff'
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255,255,255,0.16)'
      },
      '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255,255,255,0.28)'
      },
      '& input': {
        color: '#fff'
      },
      '& input::placeholder': {
        color: 'rgba(255,255,255,0.62)',
        opacity: 1
      }
    },
    
    inputField: {
      marginBottom: '20px !important',
    },
    textArea: {
      width: '100%',
      marginBottom: '20px',
      fontSize: '16px',
      padding: '10px',
    },
    footerContainer: {
      display: 'flex',
      alignItems: 'center',
      minHeight: '10vh',
      padding: '24px 20px',
      justifyContent: 'center',
      backgroundColor: '#ffffff',
      flexDirection: 'column',
      borderTop: '1px solid rgba(0,0,0,0.06)',
      boxShadow: '0 -6px 18px rgba(0,0,0,0.04)',
      zIndex: 5,
      color: colors.Button_Primary || '#b78b00',
    },
    /* Utilities to allow a component to overlap the footer or other sections */
    overlapWrapper: {
      position: 'relative',
      // make sure overlapping children can use absolute positioning
      zIndex: 1,
    },
    overlapWidget: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      bottom: '48px',
      zIndex: 10,
      // visual defaults for a floating card
      background: '#ffffff',
      borderRadius: 12,
      boxShadow: '0 12px 30px rgba(0,0,0,0.18)',
      padding: 16,
      minWidth: 280,
      maxWidth: '88%',
    },
    footerText: {
      paddingBottom: '10px',
      color: colors.Button_Primary || '#b78b00',
    },
    footerDate: {
      opacity: '0.4',
    },
    testimonialCard: {
      backgroundColor: '#fff',
      padding: '10px',
      minHeight: '200px',
      display: 'flex',
      alignItems: 'center',
    },
    testimonialStatement: {
      paddingBottom: '25px',
    },
    avatar: {
      marginRight: '10px',
    },
    testimonialPosition: {
      fontSize: '14px',
      opacity: '0.6',
    },
  };
};

const useStyles = makeStyles(styles);
export default useStyles;